module.exports = __webpack_public_path__ + "img/order-status-check.a984749c.png";